import { render, staticRenderFns } from "./VariationList.vue?vue&type=template&id=18d08f74&scoped=true"
import script from "./VariationList.vue?vue&type=script&lang=js"
export * from "./VariationList.vue?vue&type=script&lang=js"
import style0 from "./VariationList.vue?vue&type=style&index=0&id=18d08f74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d08f74",
  null
  
)

export default component.exports